'use client'

import FlashMessage from '@/context/flash-message'
import UAParserContext, { type UAParserProps } from '@/context/ua-parser'
import UserContext, { type UserContextProps } from '@/context/user-context'
import { getUserOnClient } from '@/util/user'
import type { ReactNode } from 'react'
import { useCallback, useEffect, useState } from 'react'
import type { ILoggedInUser } from 'types'

type Props = {
    children: ReactNode
} & UAParserProps &
    UserContextProps

const MemeMakerContextManager = ({ children, deviceType, hasFetchedUser, isBot, user: userSSR }: Props) => {
    const [user, setUser] = useState<ILoggedInUser | null | undefined>(hasFetchedUser ? userSSR || null : undefined)

    const refreshUser = useCallback(async () => {
        try {
            const nextUser = await getUserOnClient()
            const normalizedUser = nextUser || null
            setUser(normalizedUser)
            return normalizedUser
        } catch (error) {
            setUser(null)
            return null
        }
    }, [])

    useEffect(() => {
        if (user === undefined) {
            void refreshUser()
        }
    }, [refreshUser, user])

    return (
        <UAParserContext.Provider value={{ deviceType, isBot }}>
            <UserContext.Provider value={{ user, hasFetchedUser: user !== undefined, refreshUser }}>
                <FlashMessage>{children}</FlashMessage>
            </UserContext.Provider>
        </UAParserContext.Provider>
    )
}

export default MemeMakerContextManager
